import styled from "styled-components";

export const CommEarningContainer = styled.div`
    margin-bottom: 40px;
    font-size: 12px;
    border: 1px solid #E4E4E4;
    border-radius: 4px;
    & .tabList{
        display:flex ;
        background-color: #fff;

        border-radius: 4px 4px 0 0;
        border-bottom: 1px solid #E4E4E4;
        

        & .tab{
            padding: 16px 30px;
            cursor: pointer;
            display: flex;
            flex: 1;

             :not(:last-child){
                border-right: 1px solid #E4E4E4;
            }


            & .date{
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    display: flex;
                    align-items: center;

                    color: #757575;

                    span{
                        margin-right: 4px;
                    }
            }
            
        }

        & .active{
            background-color: #F0F6F9;
            border-bottom: 4px solid #008CFF;

            & .date{
                color: #008CFF;
                font-weight: 900;
            }

            & .rightArrowIcon{
                background-position: -66px -67.5px;

            }
        }
    }

    & .tabContent{
        display: flex;
        padding: 30px 32px;
        background-color: #F9F9F9;
        border-radius: 0 0 4px 4px;
        & .commEarningData{
            width: 60%;
            border-right: 1px solid #DDDDDD;
            & .comEarning{
                margin-bottom: 8px;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                /* identical to box height, or 150% */


                color: #000000;

                & span{
                    color: #757575;
                    font-weight: 400;
                    font-size: 12px;
                }
            }

            & .totalPrice{
                margin-bottom: 4px;
                font-weight: 900;
                font-size: 32px;
                line-height: 40px;
            }

            & .priceBreakUp{
                color: #757575;
                span{
                    font-weight: 900;
                }
            }
        }
        & .commEarningAction{
            width: 40%;
            padding-left: 38px;

            & .btnLabel{
                font-weight: 700;
                font-size: 12px;
                line-height: 16px;
                margin-bottom:10px ;
            }
        }
    }

`
